import apiClient from '../../shared/services/apiClient';

/**
 * 云盘（disk.yeap.cloud）控制台接口 — /api/user/disk/*（契约见 docs/disk/SPEC.md §4）。
 * 每个方法返回后端 body（{success, data, message}）；HTTP 4xx/5xx 时抛出 {success:false, error, reason, status}。
 */
const BASE = '/api/user/disk';

const call = async (p) => {
    try {
        const res = await p;
        return res.data;
    } catch (e) {
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { ...body, success: false, status: e?.response?.status, error: body.error || body.message || e?.message };
    }
};

const diskService = {
    overview: () => call(apiClient.get(`${BASE}/overview`)),
    /** 一次性 SSO 票据 → {url}；account_id 省略 = 个人空间 */
    sso: (accountId) => call(apiClient.post(`${BASE}/sso`, accountId ? { account_id: accountId } : {})),

    getOrg: (id) => call(apiClient.get(`${BASE}/orgs/${id}`)),
    renameOrg: (id, name) => call(apiClient.patch(`${BASE}/orgs/${id}`, { name })),

    listMembers: (orgId) => call(apiClient.get(`${BASE}/orgs/${orgId}/members`)),
    createMember: (orgId, data) => call(apiClient.post(`${BASE}/orgs/${orgId}/members`, data)),
    updateMember: (orgId, id, data) => call(apiClient.patch(`${BASE}/orgs/${orgId}/members/${id}`, data)),
    resetMemberPassword: (orgId, id) => call(apiClient.post(`${BASE}/orgs/${orgId}/members/${id}/reset-password`, {})),
    deleteMember: (orgId, id) => call(apiClient.delete(`${BASE}/orgs/${orgId}/members/${id}`)),

    /** 套餐变更选项（升级/降级），按订阅查 */
    planOptions: (subscriptionId) => call(apiClient.get('/api/user/subscription-info/available-upgrades', {
        params: { product_type: 'disk', subscription_id: subscriptionId },
    })),
};

/** 打开网盘：先开空白窗口再赋地址，避免异步后被浏览器拦截弹窗 */
export const openDisk = async (accountId, onError) => {
    const win = window.open('about:blank', '_blank');
    if (win) win.opener = null;
    try {
        // accountId 可以是异步解析函数（先查组织详情拿身份）
        const id = typeof accountId === 'function' ? await accountId() : accountId;
        const r = await diskService.sso(id);
        const url = r?.data?.url;
        if (!url) throw new Error('no url');
        if (win) win.location.href = url; else window.location.href = url;
    } catch (e) {
        if (win) win.close();
        onError && onError(e);
    }
};

export default diskService;
